import { render, staticRenderFns } from "./ForestJuvenilesEN.vue?vue&type=template&id=54722f8a&scoped=true"
import script from "./ForestJuvenilesEN.vue?vue&type=script&lang=js"
export * from "./ForestJuvenilesEN.vue?vue&type=script&lang=js"
import style0 from "./ForestJuvenilesEN.vue?vue&type=style&index=0&id=54722f8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54722f8a",
  null
  
)

export default component.exports